import {
  AfterViewInit,
  Directive,
  ElementRef,
  NgZone,
  inject,
  input,
  output,
} from '@angular/core';
import { fromEvent } from 'rxjs';

@Directive({
  selector: '[libScrollTrigger]',
})
export class ScrollTrigger implements AfterViewInit {
  readonly elementRef = inject(ElementRef);
  readonly zone = inject(NgZone);

  readonly offset = input(0);

  readonly crossed = output<boolean>();

  ngAfterViewInit(): void {
    const element = this.elementRef.nativeElement as HTMLElement;
    let lastValue: boolean | undefined;

    this.zone.runOutsideAngular(() => {
      fromEvent(element, 'scroll', { passive: true }).subscribe(() => {
        const isCrossed = element.scrollTop > this.offset();
        if (isCrossed !== lastValue) {
          lastValue = isCrossed;
          this.zone.run(() => this.crossed.emit(isCrossed));
        }
      });
    });
  }
}
